import { Command, CommandResult } from '@/_core/cqrs/types/commands';

export class MoveActivityToTrash extends Command<CommandResult> {
    public BoardActivity: any;

    public constructor(public Id: string, public StorymapId: string) {
        super('MoveActivityToTrash');
    }
}

export class MoveTaskToTrash extends Command<CommandResult> {
    public BoardActivity: any;

    public constructor(public Id: string, public StorymapId: string, public ParentActivityId: string) {
        super('MoveTaskToTrash');
    }
}

export class MoveSubtaskToTrash extends Command<CommandResult> {
    public BoardActivity: any;

    public constructor(public Id: string, public StorymapId: string, public ParentTaskId: string, public ReleaseId: string) {
        super('MoveSubtaskToTrash');
    }
}

export class MoveUnscheduledSubtaskToTrash extends Command<CommandResult> {
    public BoardActivity: any;

    public constructor(public Id: string, public StorymapId: string, public ParentTaskId: string) {
        super('MoveUnscheduledSubtaskToTrash');
    }
}
